import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "flex justify-content-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "mailing-list-dialogue",
    modal: true,
    maximizable: true,
    visible: _ctx.show,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.show) = $event))
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "sticky-button",
              icon: _ctx.isBulkUpdateContactsEnabled ? 'pi pi-user' : 'pi pi-users',
              label: _ctx.isBulkUpdateContactsEnabled ? 'Update Individually' : 'Update All',
              onClick: _ctx.toggleisBulkUpdateContactsEnabled
            }, null, 8, ["icon", "label", "onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.loading && _ctx.isBulkUpdateContactsEnabled && !_ctx.allContactsArchived)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "sticky-button",
              icon: "pi pi-trash",
              label: "Delete All",
              onClick: _ctx.archiveAllAContacts
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.loading && _ctx.isBulkUpdateContactsEnabled && !_ctx.allContactsActive)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              class: "sticky-button",
              icon: "pi pi-refresh",
              label: "Restore All",
              onClick: _ctx.restoreAllContacts
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 3,
              class: "sticky-button",
              icon: "pi pi-save",
              label: _ctx.isBulkUpdateContactsEnabled ? 'Save all' : 'Save',
              onClick: _ctx.saveContacts,
              disabled: !_ctx.hasChanges
            }, null, 8, ["label", "onClick", "disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_DataTable, {
        stripedRows: "",
        class: "p-datatable-sm mailing-list-datatable",
        scrollHeight: "flex",
        responsiveLayout: "scroll",
        value: _ctx.filteredSelectedContacts,
        rows: 100,
        rowClass: _ctx.rowClass,
        scrollable: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "firstName",
            header: "First name",
            class: "flex-grow"
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_InputText, {
                modelValue: data.firstName,
                "onUpdate:modelValue": ($event: any) => ((data.firstName) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "lastName",
            header: "Last name",
            class: "flex-grow"
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_InputText, {
                modelValue: data.lastName,
                "onUpdate:modelValue": ($event: any) => ((data.lastName) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          (_ctx.windowWidth >= 1200)
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 0,
                field: "jobTitle",
                header: "Job title",
                class: "flex-grow"
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_InputText, {
                    modelValue: data.jobTitle,
                    "onUpdate:modelValue": ($event: any) => ((data.jobTitle) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Column, {
            field: "email",
            header: "Email",
            class: "flex-grow"
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_InputText, {
                modelValue: data.email,
                "onUpdate:modelValue": ($event: any) => ((data.email) = $event),
                type: "email"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "mobile",
            header: "Mobile",
            class: "flex-grow"
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_InputText, {
                modelValue: data.mobile,
                "onUpdate:modelValue": ($event: any) => ((data.mobile) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          (_ctx.windowWidth >= 1200)
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 1,
                field: "Ddi",
                header: "Landline",
                class: "flex-grow"
              }, {
                body: _withCtx(({data}) => [
                  _createVNode(_component_InputText, {
                    modelValue: data.ddi,
                    "onUpdate:modelValue": ($event: any) => ((data.ddi) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isBulkUpdateContactsEnabled && _ctx.windowWidth >= 1200)
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 2,
                field: "companyName",
                header: "Company",
                class: "flex-grow"
              }, {
                body: _withCtx(({data}) => [
                  (data.companyId && !data.isCompanyDeleted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_router_link, {
                          to: !data.isCompanyDeleted ? { name: 'CompanyDetails', params: { companyId: data.companyId } } : null
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(data.companyName), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        (!data.isCompanyActive)
                          ? (_openBlock(), _createBlock(_component_Badge, {
                              key: 0,
                              class: "small-grey-badge ml-1",
                              value: "inactive"
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_2, "-"))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isBulkUpdateContactsEnabled && _ctx.windowWidth >= 992)
            ? (_openBlock(), _createBlock(_component_Column, { key: 3 }, {
                body: _withCtx(({data}) => [
                  _createElementVNode("div", {
                    title: _ctx.getTooltipText(data.isCompanyActive, data.isActive)
                  }, [
                    (!_ctx.loading && data.isActive)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          icon: "pi pi-trash",
                          onClick: ($event: any) => (_ctx.archiveContact(data))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (!_ctx.loading && !data.isActive)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          icon: "pi pi-refresh",
                          onClick: ($event: any) => (_ctx.restoreContact(data)),
                          disabled: !data.isCompanyActive
                        }, null, 8, ["onClick", "disabled"]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_3)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "rowClass"]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressSpinner, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible"]))
}